import { render, staticRenderFns } from "./SiteTreePageItemSelectMenu.vue?vue&type=template&id=3e4d8b44&scoped=true"
import script from "./SiteTreePageItemSelectMenu.vue?vue&type=script&lang=js"
export * from "./SiteTreePageItemSelectMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e4d8b44",
  null
  
)

export default component.exports